// Serialize a Date as YYYY-MM-DDTHH:mm:ss using LOCAL components (no `Z`, no
// offset, no milliseconds). Use this instead of `.toISOString()` for any
// wall-clock value sent to the backend — `.toISOString()` converts to UTC and
// emits a trailing `Z`, which the server re-interprets against its own timezone
// and drifts the stored time (e.g. +30 min for half-hour zones).
export function toLocalISOString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    const second = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
}

export function getYYYYMMDDString(date: Date | string): string {
    if (typeof date === 'string') {
        date = new Date(date);
    }

    if (!date) {
        return ''
    }

    if (isNaN(date.getTime())) {
        throw new Error('Invalid date provided')
    }

   return `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
}

export function getDDMMYYYYString(date: Date | string): string {
    if (typeof date === 'string') {
        date = new Date(date);
    }

    if (!date || isNaN(date.getTime())) {
        return '' 
    }

    return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
}

export function get12HourTimeString(date: Date | string): string {
    if (typeof date === 'string') {
        date = new Date(date);
    }

    if (!date || isNaN(date.getTime())) {
        return ''
    }

    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const twelveHour = hours % 12 || 12; // Convert to 12-hour format

    return `${twelveHour}:${minutes} ${ampm}`;
}

export function get24HourTimeString(date: Date | string): string {
    if (typeof date === 'string') {
        date = new Date(date);
    }

    if (!date || isNaN(date.getTime())) {
        return ''
    }

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${hours}:${minutes}`;
}

export function formatDateToUserTimezone(isoString: string): string {
    const date = new Date(isoString);
    const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    };

    return date.toLocaleDateString(undefined, options);
}

export function formatDateToYYYYMMDD(isoString: string): string {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}